import React from "react";
import ChrLink from "../../Utils/ChrLink";
import { eventTracker, getEventDetails } from "../../Utils/eventTracker";
import { getHoverOptions } from "../../Utils/commonUtils";
/*
props = {
  data: {
    className: <string>,
    url: <URL>,
    label: <string>,
    eventDetails: <hash>,
    onClick: <handler>
  }
}
*/

const ButtonTemplate = (props) => {
  const actionData = props.data;
  const { prefixIcon, suffixIcon, hoverText } = actionData;
  const { eventName, payload } = getEventDetails(actionData.eventDetails);
  const getWrapperOptions = (hoverText && getHoverOptions(hoverText)) || {};

  const clickHandler = () => {
    props.onClick?.();
    eventTracker(eventName, payload);
  };

  const defaultButtonContent = () => {
    return <div { ...getWrapperOptions } className="d-flex align-items-center flex-gap-5" tabIndex='0'>
      { prefixIcon &&
        <div>
          <i { ...prefixIcon } />
        </div>
      }
      {
        actionData.label &&
        <div>
          { actionData.label }
        </div>
      }
      { suffixIcon &&
        <div>
          <i { ...suffixIcon } />
        </div>
      }
    </div>
  }

  return (
    <ChrLink className={ actionData.className } newTab={ actionData.newTab } href={ actionData.url } onClick={ clickHandler } noHref { ...props.extraProps }>
      { props.buttonContent || defaultButtonContent() }
    </ChrLink>
  );
};

export default ButtonTemplate;
